import { render } from "./NativeComponentPropsCmp.vue?vue&type=template&id=a3c08cce"
import script from "./NativeComponentPropsCmp.vue?vue&type=script&lang=js"
export * from "./NativeComponentPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__